import { cn } from "@/lib/utils";

export type MapStylePreviewChipsProps = {
  fillColor: string;
  lineColor: string;
  /** Толщина линии (px); показывается компактно, если ≠ базовой. */
  lineWidth?: number | null;
  lineDashCode?: string | null;
  /** Базовая толщина — не показывать число, если совпадает. */
  baselineWidth?: number;
  /** Есть ли собственный override (не только наследование). */
  hasOverride?: boolean;
  className?: string;
  title?: string;
};

/**
 * Компактная сводка стиля карты: два swatch + опционально пунктир/толщина.
 * Для списков и toolbar (как «Стиль сущности по умолчанию»).
 */
export function MapStylePreviewChips({
  fillColor,
  lineColor,
  lineWidth = null,
  lineDashCode = null,
  baselineWidth = 2,
  hasOverride = false,
  className,
  title,
}: MapStylePreviewChipsProps) {
  const dash = (lineDashCode ?? "solid").toLowerCase();
  const width = lineWidth != null && Number.isFinite(lineWidth) ? Number(lineWidth) : null;
  const showWidth = width != null && Math.abs(width - baselineWidth) > 0.05;
  const showDash = dash === "dashed";

  return (
    <span
      className={cn("inline-flex items-center gap-0.5 shrink-0", className)}
      title={title}
      aria-label={title}
    >
      <span
        className="inline-block h-3 w-3 rounded-sm border border-border"
        style={{ backgroundColor: fillColor }}
        aria-hidden
      />
      <span
        className="inline-block h-3 w-3 rounded-sm border border-border"
        style={{ backgroundColor: lineColor }}
        aria-hidden
      />
      {showDash ? (
        <span className="px-0.5 font-mono text-[10px] leading-none text-muted-foreground" aria-hidden>
          ··
        </span>
      ) : null}
      {showWidth ? (
        <span className="tabular-nums text-[10px] leading-none text-muted-foreground" aria-hidden>
          {Number.isInteger(width) ? width : width!.toFixed(1)}
        </span>
      ) : null}
      {hasOverride ? (
        <span
          className="ml-0.5 h-1 w-1 rounded-full bg-foreground/50"
          title="Свой override"
          aria-hidden
        />
      ) : null}
    </span>
  );
}
